import type React from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '@stores/RootStore';

type WithLoginOptions = {
  allowLimitedToken?: boolean;
};

export const withLogin = (WrappedComponent: React.ComponentType, options?: WithLoginOptions) => {
  const { allowLimitedToken = false } = options ?? {};

  const Component = observer((props: UnknownObject) => {
    const { authStore, uiStore } = useStore();
    const location = useLocation();
    const navigate = useNavigate();

    const { tenantId } = useParams();

    const isAuthorized = authStore.isLogin && (allowLimitedToken || !authStore.isLimitedToken);

    useEffect(() => {
      if (!isAuthorized) {
        if (authStore.isLimitedToken && !allowLimitedToken) {
          authStore.logout();
        }
        navigate(uiStore.isItAdminTypeUi ? `/manager/${tenantId}/login` : '/login', {
          state: { routeAfterLogin: location.pathname, tenantId },
        });
      }
    }, [isAuthorized, authStore.isLimitedToken, location, navigate, tenantId, uiStore.isItAdminTypeUi]);

    return isAuthorized ? <WrappedComponent {...props} /> : null;
  });

  return Component;
};
